import React from "react";
import PageHealthyMe from "./components/PageHealthyMe";
import { RequisitionBranchProvider } from "./context";

const Index = ({ match, history }) => {
  return (
    <RequisitionBranchProvider>
      <PageHealthyMe />
    </RequisitionBranchProvider>
  );
};

export default Index;
